import html from './html.json'
import css from './css.json'
import javascript from './javascript.json'
import react from './react.json'
import typescript from './typescript.json'
import nextjs from './nextjs.json'

const htmlQuestions = { html, css, javascript, react, typescript, nextjs }

export default htmlQuestions